import { render, staticRenderFns } from "./InterventionPlanManual.vue?vue&type=template&id=21880714&scoped=true"
import script from "./InterventionPlanManual.vue?vue&type=script&lang=js"
export * from "./InterventionPlanManual.vue?vue&type=script&lang=js"
import style0 from "./InterventionPlanManual.vue?vue&type=style&index=0&id=21880714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21880714",
  null
  
)

export default component.exports